import { cellRenderParseData } from '../../utils/functions';

const columnDataClientArrival = [
  {
    dataField: 'clientArrivalDate',
    caption: 'Дата факт. прибытия',
    dataType: 'string',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'clientDeliveryTime',
    caption: 'Срок доставки',
    dataType: 'string'
  }
];

export default columnDataClientArrival;
